import React from "react";

class ErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }
  
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="min-h-[80vh] flex justify-center items-center max-w-4xl mx-auto px-4">
          <h1 className="text-blue-600 text-2xl font-medium text-center">
            Oops! something went wrong! try again
          </h1>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
